<script>
import TextInput from '@/components/form/Inputs/TextInput'
import FormPanel from '@/components/form/FormPanel'

export default {
    components: {
        TextInput,
        FormPanel,
    },

    data() {
        return {
            name: null,
            areaModel: {
                '@type': 'RestaurantArea',
                area: [],
                deliveryDelay: 0,
                deliveryMaxTime: 0,
                deliveryMinTime: 0,
                deliveryPrice: 0,
                deliveryPriceLimit: 0,
                minimumOrder: 0,
                deliveryRadius: null,
                isActive: true,
                name: null,
            },
        }
    },

    methods: {
        addArea() {
            const area = { ...this.areaModel, name: this.name }
            this.$emit('added', area)
            this.name = null
        },
    },
}
</script>

<template>
    <form-panel :title="$t('labels.add_delivery_area')">
        <div class="d-flex align-center justify-space-between">
            <text-input
                v-model="name"
                v-validate="'min:2|max:255|space'"
                name="name"
                label="labels.name"
                :error-messages="errors.collect('name')"
                :data-vv-as="$t('labels.name')"
            ></text-input>
            <v-btn
                class="ma-2"
                :disabled="!name"
                outlined
                color="success"
                @click="addArea"
            >
                <v-icon left>add</v-icon> {{ $t('actions.add') }}
            </v-btn>
        </div>
    </form-panel>
</template>
